import { render, staticRenderFns } from "./PushSend.vue?vue&type=template&id=2e2a7a84&"
import script from "./PushSend.vue?vue&type=script&lang=js&"
export * from "./PushSend.vue?vue&type=script&lang=js&"
import style0 from "./PushSend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports